import YhcAreaSelect from '@/framework/components/YhcAreaSelect';
import YhcCheckTime from '@/framework/components/YhcCheckTime';
import YhcInput from '@/framework/components/YhcInput';
import YhcRadio from '@/framework/components/YhcRadio';
import YhcCheckbox from '@/framework/components/YhcCheckbox';
import YhcSwitch from '@/framework/components/YhcSwitch';
import YhcSelect from '@/framework/components/YhcSelect';
import YhcCascader from '@/framework/components/YhcCascader';
import YhcTextarea from '@/framework/components/YhcTextarea';
import YhcDatePicker from '@/framework/components/YhcDatePicker';
import YhcWeekDatePicker from '@/framework/components/YhcWeekDatePicker';
import YhcTimePicker from '@/framework/components/YhcTimePicker';
import YhcDateTimePicker from '@/framework/components/YhcDateTimePicker';
import YhcUpLoad from '@/framework/components/YhcUpLoad';
import YhcInputRange from '@/framework/components/YhcInputRange';
import YhcColorPicker from '@/framework/components/YhcColorPicker';

import '@/framework/components/icons';

let setComponent = {};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const requireComponent = require.context('@/components/', true, /\.vue$/);

setComponent.install = function (Vue, options) {
  requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);

    const componentName = capitalizeFirstLetter(
      // 因为得到的filename格式是：'./componentX.vue',所以去掉头和尾保留真正的文件名
      fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
    );

    if (componentName === 'YhcTpl') {
      return;
    }

    Vue.component(componentName, componentConfig.default || componentConfig);
  });

  Vue.component('YhcAreaSelect', YhcAreaSelect);
  Vue.component('YhcCheckTime', YhcCheckTime);
  Vue.component('YhcInput', YhcInput);
  Vue.component('YhcRadio', YhcRadio);
  Vue.component('YhcCheckbox', YhcCheckbox);
  Vue.component('YhcSwitch', YhcSwitch);
  Vue.component('YhcSelect', YhcSelect);
  Vue.component('YhcCascader', YhcCascader);
  Vue.component('YhcTextarea', YhcTextarea);
  Vue.component('YhcDatePicker', YhcDatePicker);
  Vue.component('YhcWeekDatePicker', YhcWeekDatePicker);
  Vue.component('YhcTimePicker', YhcTimePicker);
  Vue.component('YhcDateTimePicker', YhcDateTimePicker);
  Vue.component('YhcUpLoad', YhcUpLoad);
  Vue.component('YhcInputRange', YhcInputRange);
  Vue.component('YhcColorPicker', YhcColorPicker);
};

export default setComponent;
